import React, {useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import {Collapse as AntCollapse, Form} from 'antd'
import {observer} from 'mobx-react'
import {Collapse, Input, Select} from '@/components'
import {TeamManagementFilterFormProps} from './props'
import styles from './styles.scss'
import {
    TEAMMATE_EMAIL,
    TEAMMATE_EMAIL_FILTER,
    TEAMMATE_FIRST_NAME_FILTER,
    TEAMMATE_LAST_NAME_FILTER,
    TEAMMATE_STATUS_FILTER,
    TEAMMATE_STORE_FILTER,
    TEAMMATE_AUTH_METHOD_FILTER, EXPAND_FILTER
} from '@/constants/playwright-ids'

const {Panel} = AntCollapse

export const TeamManagementFilterForm: React.FC<TeamManagementFilterFormProps> = observer(
    ({
        formId,
        form,
        onFinish,
        stores,
        statuses,
        authMethods,
        isInvitedTabActive,
        onStoreChange,
        onStatusChange,
        onFormValuesChange,
        onAuthMethodChange,
        values
    }) => {
        const { t } = useTranslation()
        useEffect(() => {
            form.setFieldsValue({...values})
        }, [values])

        return (
            <Form
                id={formId}
                form={form}
                onFinish={onFinish}
                initialValues={{
                    store: stores && stores[0].value,
                    authMethod: authMethods && authMethods[0].value,
                    ...(statuses.length > 0 ? {status: statuses && statuses[0]?.value} : {})
                }}
                onValuesChange={(changedValues, allValues) => {
                    onFormValuesChange(allValues)
                }}
            >
                <Collapse defaultActiveKey={['email']}>
                    <Panel
                        className={styles.panel}
                        header={t('TeamManagementFilterForm.labels.email')}
                        key='email'
                        data-test-id={EXPAND_FILTER + '_' + TEAMMATE_EMAIL_FILTER}
                    >
                        <Form.Item
                            className={styles.formItem}
                            name='email'
                        >
                            <Input
                                className={styles.input}
                                data-test-id={TEAMMATE_EMAIL_FILTER}
                                placeholder={t('TeamManagementFilterForm.labels.email')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel
                        className={styles.panel}
                        header={t('TeamManagementFilterForm.labels.firstName')}
                        key='firstName'
                        data-test-id={EXPAND_FILTER + '_' + TEAMMATE_FIRST_NAME_FILTER}
                    >
                        <Form.Item className={styles.formItem} name='firstName'>
                            <Input
                                className={styles.input}
                                data-test-id={TEAMMATE_FIRST_NAME_FILTER}
                                placeholder={t('TeamManagementFilterForm.labels.firstName')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel
                        className={styles.panel}
                        header={t('TeamManagementFilterForm.labels.lastName')}
                        key='lastName'
                        data-test-id={EXPAND_FILTER + '_' + TEAMMATE_LAST_NAME_FILTER}
                    >
                        <Form.Item className={styles.formItem} name='lastName'>
                            <Input
                                className={styles.input}
                                data-test-id={TEAMMATE_LAST_NAME_FILTER}
                                placeholder={t('TeamManagementFilterForm.labels.lastName')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel
                        className={styles.panel}
                        header={t('TeamManagementFilterForm.labels.store')}
                        key='store'
                        data-test-id={EXPAND_FILTER + '_' + TEAMMATE_STORE_FILTER}
                    >
                        <Form.Item className={styles.formItem} name='store'>
                            <Select
                                className={styles.select}
                                bordered={false}
                                options={stores}
                                placeholder={t('TeamManagementFilterForm.labels.store')}
                                onChange={onStoreChange}
                                showSearch
                            />
                        </Form.Item>
                    </Panel>
                    {statuses.length > 0 ? (
                        <Panel
                            className={styles.panel}
                            header={t('TeamManagementFilterForm.labels.status')}
                            key='status'
                            data-test-id={EXPAND_FILTER + '_' + TEAMMATE_STATUS_FILTER}
                        >
                            <Form.Item className={styles.formItem} name='status'>
                                <Select
                                    className={styles.select}
                                    bordered={false}
                                    options={statuses}
                                    placeholder={t('TeamManagementFilterForm.labels.status')}
                                    onChange={onStatusChange}
                                    showSearch
                                />
                            </Form.Item>
                        </Panel>
                    ) : null}

                    {!isInvitedTabActive && (
                        <Panel
                            className={styles.panel}
                            header={t('TeamManagementFilterForm.labels.authMethod')}
                            key='authMethod'
                            data-test-id={EXPAND_FILTER + '_' + TEAMMATE_AUTH_METHOD_FILTER}
                        >
                            <Form.Item className={styles.formItem} name='authMethod'>
                                <Select
                                    className={styles.select}
                                    bordered={false}
                                    options={authMethods}
                                    placeholder={t('TeamManagementFilterForm.labels.authMethod')}
                                    onChange={onAuthMethodChange}
                                    showSearch
                                />
                            </Form.Item>
                        </Panel>
                    )}
                </Collapse>
            </Form>
        )
    }
)
